<section class="widget-section order-1" id="app-my-collaboration-activities-widget">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-colleagues></app-colleagues>
  </div>
</section>
<section class="widget-section order-2" id="app-my-latest-sites">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-collaboration-activities-widget></app-my-collaboration-activities-widget>
  </div>
</section>
<section class="widget-section order-3" id="app-colleagues">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-latest-sites></app-my-latest-sites>
  </div>
</section>
<section class="widget-section order-4" id="app-site-index">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
      <app-site-index></app-site-index>
  </div>
</section>
